var map = {
	"./": [
		238
	],
	"./Farm": [
		502,
		0
	],
	"./Farm.tsx": [
		502,
		0
	],
	"./Nfts": [
		505,
		1
	],
	"./Nfts.tsx": [
		505,
		1
	],
	"./Pools": [
		503,
		2
	],
	"./Pools.tsx": [
		503,
		2
	],
	"./Wallet": [
		504,
		3
	],
	"./Wallet.tsx": [
		504,
		3
	],
	"./index": [
		238
	],
	"./index.tsx": [
		238
	],
	"./styleds": [
		499,
		4
	],
	"./styleds.tsx": [
		499,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 806;
module.exports = webpackAsyncContext;